import Cookies from "js-cookie";
import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_COOKIES_SECRET_KEY;

// Encrypt data
export const encryptData = (data) => {
  return CryptoJS.AES.encrypt(data, SECRET_KEY).toString();
};

// Decrypt data
export const decryptData = (ciphertext) => {
  try {
    const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};

// Set encrypted cookie
export const setEncryptedCookie = (name, value, days = 400) => {
  const encryptedValue = encryptData(value);
  Cookies.set(name, encryptedValue, {
    expires: days,
    secure: true,
    sameSite: "Strict",
  });
};

export const setEncryptedMfaTempData = (data, minutes = 9) => {
  const encryptedValue = encryptData(JSON.stringify(data));

  const days = minutes / (60 * 24);

  Cookies.set("mfa_temp_data", encryptedValue, {
    expires: days,
    secure: true,
    sameSite: "Strict",
  });
};

export const getDecryptedMfaTempData = () => {
  const encryptedValue = Cookies.get("mfa_temp_data");
  if (!encryptedValue) return null;

  try {
    const decryptedValue = decryptData(encryptedValue);
    return JSON.parse(decryptedValue);
  } catch (error) {
    return null;
  }
};

export const clearMfaTempData = () => {
  Cookies.remove("mfa_temp_data");
};

// Get decrypted cookie
export const getDecryptedCookie = (name) => {
  const encryptedValue = Cookies.get(name);
  return encryptedValue ? decryptData(encryptedValue) : null;
};

// Remove cookie
export const removeCookie = (name) => {
  Cookies.remove(name);
};
